// Shared by the server (POST /sources/new builds `cmd_hint`) and the Console UI
// (DestinationForm renders the same command on screen). Both put a source name
// into a shell command, and both must quote it identically — a name is only
// validated with ALIAS_PATTERN, whose `A-z` range spans ASCII 91-96 and so
// admits ` and \, and names also arrive from the platform API and from sources
// predating any validation.

// Unquoted only when the value is plainly inert in a shell. Otherwise wrap in
// single quotes, where the sole special character is `'` itself: close the
// quote, emit an escaped quote, reopen. Produces POSIX-safe output for any
// input, including newlines.
export const shellQuote = (value: string): string =>
  /^[A-Za-z0-9._-]+$/.test(value) ? value : `'${value.replace(/'/g, `'\\''`)}'`;
